var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import _ from 'lodash';
import moment from 'moment';
import EHandleStatus, { EHanldeStatus } from '../../enum/EHandleStatus';
import { auth } from '../../helper/authDecorator';
import { weekDefaultDate } from '../../helper/defaultDate';
import { UrlHelper } from '../../helper/UrlWrapper';
import { nameDict } from '../../constant/authCode';
import GLOBAL_VUE from '../../globalVue';
import QuotedPrice from '../../api/QuotedPrice';
import PurchaseService from '../../api/PurchaseService';
import { summaries } from '../../helper/util';
import AddDialog from './components/GoodAdd.vue';
import Header from './components/AddHeader.vue';
import TableHeaderToolTip from './components/TableHeaderToolTip.vue';
import RequiredMixin from '../../components/renderHeader/RequiredMixin';
export var ESaveType;
(function (ESaveType) {
    ESaveType[ESaveType["SAVE"] = 1] = "SAVE";
    ESaveType[ESaveType["SAVE_PRINT"] = 2] = "SAVE_PRINT";
})(ESaveType || (ESaveType = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.canedit = true;
        _this.tableHeight = document.documentElement.clientHeight - 280;
        _this.data = [];
        _this.formData = {
            order_type: 1,
            order_sub_type: 1,
            warehouse_date: weekDefaultDate().Start,
            organ_id: '',
            depot_id: '',
            supplier_upper_id: '',
            purchasing_agent_id: '',
            order_icomment: '',
        };
        _this.enumStatus = EHandleStatus;
        _this.handleStatus = EHandleStatus.Add;
        _this.ESaveType = ESaveType;
        _this.from_system = 3;
        _this.orderid = '';
        _this.total = 0;
        _this.start = 0;
        _this.limit = 20;
        _this.dialogTableVisible = false;
        _this.dialogTableEditVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = '';
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = '';
        _this.emptyMoneyCanSubmit = false;
        _this.notAllEmptyFlag = true;
        _this.emptyFlag = true;
        _this.goods_format_ids = [];
        _this.canSave = true;
        _this.fromAction = '';
        _this.importSuccessBusinessNum = 0;
        _this.importSuccessShopNum = 0;
        _this.supplierUpperId = '';
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            },
        };
        return _this;
    }
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls"))) {
            this.$message.error("文件只能是xlsx或xls");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    default_1.prototype.uploadSuccess = function (response, file, fileList) {
        var _this = this;
        if (response.success) {
            var dataVal = response.data;
            this.responseSuccess = dataVal.import_id ? true : false;
            this.importFailnum = dataVal.error_num;
            var url = "/basicapi/export_error?import_id=" + dataVal.import_id + "&type=" + dataVal.type;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            var goodsList = dataVal.goods_list || [];
            console.log(444, goodsList);
            if (goodsList.length) {
                var newData = _.uniqBy(goodsList.concat(this.data), 'goods_format_id');
                newData = newData.map(function (item) {
                    return __assign({}, item, { order_detail_tax_rate: item.order_detail_tax_rate || item.tax_rate, order_detail_uprice: item.order_detail_uprice || item.goods_price });
                });
                var currentDay_1 = moment().format('YYYY-MM-DD');
                newData.map(function (good) {
                    good.production_date = good.production_date || currentDay_1;
                    good.shelflife = good.shelflife || 0;
                    good.expire_date = good.expire_date || _this.resetDate(good.production_date, good.shelflife);
                    return good;
                });
                console.log(333, newData);
                this.data = newData;
                this.total = this.data.length;
                this.selections = [];
                this.dialogTableVisible = false;
            }
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    default_1.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    default_1.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    default_1.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    default_1.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    default_1.prototype.created = function () {
        this.service = QuotedPrice.getInstance();
        this.purchaseService = PurchaseService.getInstance();
        if (this.orderid) {
            this.getDetail();
            console.log(1111, this.formData, this.orderid);
        }
    };
    default_1.prototype.mounted = function () {
        console.log(2222, this.formData.supplier_upper_id);
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        this.handleStatus = EHandleStatus.Edit;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.orderid,
        };
        this.purchaseService
            .getDetail(params)
            .then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            if (data.purchasing_agent_id === 0) {
                data.purchasing_agent_id = '';
            }
            var currentDay = moment().format('YYYY-MM-DD');
            data.detail.map(function (good) {
                good.production_date = good.production_date || currentDay;
                good.shelflife = good.shelflife || 0;
                good.expire_date = good.expire_date || _this.resetDate(good.production_date, good.shelflife);
                return good;
            });
            _this.data = data.detail;
            _this.total = res.data.total || 0;
            var goods_format_ids = (data.detail || []).map(function (good) {
                return good.goods_format_id;
            });
            _this.goods_format_ids = goods_format_ids || [];
            _this.formData = Object.assign({}, _this.formData, {
                order_type_name: data.order_type_name,
                organ_name: data.organ_name,
                depot_name: data.depot_name,
                warehouse_date: data.warehouse_date,
                supplier_upper_name: data.supplier_upper_name,
                purchasing_agent: data.purchasing_agent,
                order_icomment: data.order_icomment,
                supplier_upper_id: data.supplier_upper_id,
                order_type: data.order_type,
                order_sub_type: data.order_sub_type,
                organ_id: data.organ_id,
                depot_id: data.depot_id,
                purchasing_agent_id: data.purchasing_agent_id,
                upper_purchase_order_code: data.upper_purchase_order_code
            });
            _this.supplierUpperId = data.supplier_upper_id;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.calculate = function (row) {
        var taxMoney = 0;
        if (row.order_detail_money && row.order_detail_tax_rate) {
            taxMoney =
                (row.order_detail_money / (1 + row.order_detail_tax_rate / 100)) * (row.order_detail_tax_rate / 100);
            taxMoney = new Number(taxMoney).toFixed(4);
            row.order_detail_tax_money = taxMoney;
            return taxMoney;
        }
        else {
            row.order_detail_tax_money = 0;
        }
        return taxMoney;
    };
    default_1.prototype.checkSave = function () {
        var flag = true, msg = [];
        this.data.map(function (row) {
            if ((!row.order_detail_amount && row.order_detail_amount !== 0) || row.order_detail_amount <= 0) {
                flag = false;
                msg.push('入库数量必填，入库数量大于0');
            }
        });
        if (!flag) {
            this.$message.warning('入库数量必填，入库数量大于0');
            return false;
        }
        return true;
    };
    default_1.prototype.save = function (saveType) {
        var _this = this;
        var formData = this.formData;
        if (!this.data || !this.data.length) {
            this.$message.warning('请添加货品');
            return;
        }
        if (!this.checkSave()) {
            return;
        }
        this.canSave = false;
        if (this.handleStatus === EHanldeStatus.Add) {
            var data = this.data.map(function (item) {
                return {
                    goods_id: item.goods_id || '',
                    goods_format_id: item.goods_format_id || '',
                    supplier_upper_goods_id: item.supplier_upper_goods_id || '',
                    order_detail_amount: item.order_detail_amount || '',
                    order_detail_uprice: item.order_detail_uprice,
                    order_detail_money: item.order_detail_money,
                    order_detail_tax_money: item.order_detail_tax_money,
                    order_detail_tax_rate: item.order_detail_tax_rate,
                    order_detail_icomment: item.order_detail_icomment || '',
                    production_date: item.production_date,
                    shelflife: item.shelflife,
                    expire_date: item.expire_date,
                };
            });
            var params = __assign({}, formData, { data: JSON.stringify(data) });
            if (_.isDate(params.warehouse_date)) {
                params.warehouse_date = params.warehouse_date.format('yyyy-MM-dd');
            }
            this.purchaseService
                .addUpperwarehouse(params)
                .then(function (res) {
                _this.canSave = true;
                if (res.data.code == 3) {
                    var html = "<div>" + res.data.msg + "</div>";
                    _this.$confirm(html, '提示', {
                        dangerouslyUseHTMLString: true,
                        customClass: 'confirm',
                        confirmButtonText: '知道了',
                        showCancelButton: false,
                    }).catch(function (err) {
                        console.log(err);
                    });
                    return;
                }
                if (res.data.success) {
                    _this.$message.success('保存成功');
                    if (saveType == ESaveType.SAVE_PRINT) {
                        _this.mulPrint();
                    }
                    setTimeout(function () {
                        GLOBAL_VUE.$emit('closeTab', _this);
                        if (_this.opener) {
                            _this.opener.getList();
                        }
                    }, 500);
                }
            }, function (err) {
                _this.$message.error(err.message);
                _this.canSave = true;
            })
                .catch(function (err) {
                _this.$message.error(err.message);
                _this.canSave = true;
            });
        }
        else {
            var data = this.data.map(function (item) {
                return {
                    goods_id: item.goods_id || '',
                    goods_format_id: item.goods_format_id || '',
                    supplier_upper_goods_id: item.supplier_upper_goods_id || '',
                    order_detail_amount: item.order_detail_amount || '',
                    order_detail_uprice: item.order_detail_uprice,
                    order_detail_money: item.order_detail_money,
                    order_detail_tax_money: item.order_detail_tax_money,
                    order_detail_tax_rate: item.order_detail_tax_rate,
                    order_detail_icomment: item.order_detail_icomment || '',
                    production_date: item.production_date,
                    shelflife: item.shelflife,
                    expire_date: item.expire_date,
                };
            });
            var params = __assign({}, formData, { order_id: this.orderid, data: JSON.stringify(data) });
            this.purchaseService
                .updateUpperwarehouse(params)
                .then(function (res) {
                if (res.data.success) {
                    _this.$message.success('保存成功');
                    if (saveType == ESaveType.SAVE_PRINT) {
                        _this.mulPrint();
                    }
                    setTimeout(function () {
                        GLOBAL_VUE.$emit('closeTab', _this);
                        if (_this.opener) {
                            _this.opener.getList();
                        }
                    }, 500);
                }
            }, function (err) {
                _this.canSave = true;
                _this.$message.error(err.message);
            })
                .catch(function (err) {
                _this.$message.error(err.message);
                _this.canSave = true;
            });
        }
    };
    default_1.prototype.mulPrint = function () {
        var url = './static/js/print/print2.html';
        url = UrlHelper.addParam(url, 'type', 'purBack');
        url = UrlHelper.addParam(url, 'order_id', this.orderid);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
    };
    default_1.prototype.orderChange = function () { };
    default_1.prototype.clientChange = function (formData) { };
    default_1.prototype.toImport = function () {
        if (!this.formData.supplier_upper_id && !this.supplierUpperId) {
            this.$message.warning('请选择供应商');
            return;
        }
        this.dialogTableVisible = true;
        this.setUploadType("beford");
    };
    default_1.prototype.toAdd = function () {
        var _this = this;
        if (this.handleStatus === EHanldeStatus.Add && !this.formData.supplier_upper_id) {
            this.$message.warning('请选择供应商');
            return;
        }
        var dialog = this.$dialog(AddDialog, {
            data: {
                addedDatas: this.data,
                purchasers: this.formData.clientArray,
                supplier_upper_id: this.formData.supplier_upper_id,
                depot_id: this.formData.depot_id,
            },
        }, {
            title: '添加货品',
            width: 900,
            height: 550,
        });
        dialog.instance.$on('submit', function (res) {
            var currentDay = moment().format('YYYY-MM-DD');
            res.map(function (good) {
                good.production_date = good.production_date || currentDay;
                good.shelflife = good.shelflife || 0;
                good.expire_date = good.expire_date || _this.resetDate(good.production_date, good.shelflife);
                return good;
            });
            _this.data = res;
            _this.selections = [];
            if (_this.handleStatus === EHanldeStatus.Edit) {
            }
        });
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品');
            return;
        }
        this.$confirm('请确认是否删除该货品', '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
        }, function (err) { });
    };
    default_1.prototype.pageChange = function (pager) {
    };
    default_1.prototype.inputChange = function (row, attr1, attr2) {
        if (attr2) {
            if (row[attr1][attr2] < 0) {
                row[attr1][attr2] = Math.abs(row[attr1][attr2]);
            }
        }
        else {
            if (row[attr1] < 0) {
                row[attr1] = Math.abs(row[attr1]);
            }
        }
        if (attr1 == 'order_detail_amount' || attr1 == 'order_detail_uprice') {
            if (row[attr1])
                row[attr1] = String(row[attr1]).replace(/^(.*\..{4}).*$/, "$1");
            if (row.order_detail_amount && row.order_detail_uprice) {
                row.order_detail_money = Number(_.multiply(row.order_detail_amount * row.order_detail_uprice)).toFixedNoZero(2);
            }
            else {
                row.order_detail_money = row.order_detail_money ? row.order_detail_money : '';
            }
        }
        if (attr1 == 'order_detail_money') {
            if (row[attr1])
                row[attr1] = String(row[attr1]).replace(/^(.*\..{2}).*$/, "$1");
            if (row.order_detail_amount && row.order_detail_money) {
                row.order_detail_uprice = Number(row.order_detail_money / row.order_detail_amount).toFixedNoZero(4);
            }
            else {
                row.order_detail_uprice = row.order_detail_uprice ? row.order_detail_uprice : '';
            }
        }
        if (attr1 == 'order_detail_tax_rate') {
            this.data = _.cloneDeep(this.data);
        }
        if (attr1 == 'production_date') {
            row.expire_date = this.resetDate(row.production_date, row.shelflife);
        }
    };
    default_1.prototype.getSummaries = function (param) {
        this.tableParam = param;
        var sums = [];
        var showSum = ['order_detail_amount', 'order_detail_uprice', 'order_detail_money', 'order_detail_tax_money'];
        sums = summaries(param, showSum);
        sums[0] = '合计';
        sums[6] = '';
        sums[7] = '';
        return sums;
    };
    default_1.prototype.resetDate = function (date, days) {
        var addDay = days ? days - 1 : 0;
        return date ? moment(date).add(addDay, 'days').format('YYYY-MM-DD') : '';
    };
    default_1.prototype.getDownloadParams = function () {
        var params = this.data.map(function (item) {
            return {
                goods_code: item.goods_code || '',
                goods_name: item.goods_name || '',
                goods_format_name: item.goods_format_name || '',
                purchase_unit_name: item.purchase_unit_name || '',
                order_detail_amount: item.order_detail_amount || '',
                order_detail_uprice: item.order_detail_uprice,
                production_date: item.production_date,
                order_detail_icomment: item.order_detail_icomment || '',
            };
        });
        return JSON.stringify(params);
    };
    default_1 = __decorate([
        auth(nameDict["采购入库"], true),
        Component({
            mixins: [RequiredMixin],
            components: {
                'add-header': Header,
                TableHeaderToolTip: TableHeaderToolTip,
            },
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
            methods: {
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: '税额=含税金额/(1+税率)*税率',
                            placement: 'bottom',
                        },
                    }, '税额');
                },
            },
            watch: {
                'formData.supplier_upper_id': function (newVal, oldVal) {
                    if (!this.orderid) {
                        if (newVal != oldVal) {
                            this.data = [];
                        }
                    }
                    this.supplierUpperId = newVal;
                }
            },
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
